import React, { useState, useEffect } from "react";
import Product from "../components/Product";
import AccessoryFilterModal from "../components/AccessoryFilterModal";
import { Row, Col, Button, Container } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import InfiniteScroll from "react-infinite-scroll-component";

import Meta from "../components/Meta";

import { useDispatch, useSelector } from "react-redux";
import { listProducts } from "../actions/productActions";

function AccessoryScreen({ match, history }) {
  const [visibleProducts, setVisibleProducts] = useState(12);
  const threeMothsAgo = new Date();
  threeMothsAgo.setMonth(threeMothsAgo.getMonth() - 15);
  const timestamp = threeMothsAgo.toISOString();
  const [type, setType] = useState("All");
  const [FilteredValues, setFilteredValues] = useState([]);
  const [AccessoryProducts, setAccessoryProducts] = useState([]);

  const dispatch = useDispatch();
  const productList = useSelector((state) => state.productList);
  const { loading, error, products } = productList;

  const loadMore = () => {
    setTimeout(() => {
      // Simulate loading delay with setTimeout
      setVisibleProducts((prevVisibleProducts) => prevVisibleProducts + 12); // Increment the number of visible products
    }, 1000); // Wait for 1 second before loading more products
  };

  const filterProducts = (products, FilteredValues) => {
    const { PriceRange, brand } = FilteredValues;

    let minPrice;
    let maxPrice;

    if (PriceRange === 0) {
      minPrice = 0;
      maxPrice = 10000000;
    } else {
      minPrice = (PriceRange - 1) * 100;
      maxPrice = PriceRange * 100;
    }

    return products.filter((product) => {
      if (product.price <= minPrice || product.price >= maxPrice) {
        return false;
      }

      if (brand && product.brand !== brand) {
        return false;
      }
      return true;
    });
  };

  useEffect(() => {
    dispatch(listProducts());
  }, [dispatch]);

  // Fixed useEffect - now properly depends on both products and the category parameter
  useEffect(() => {
    if (
      products &&
      products.length > 0 &&
      match &&
      match.params &&
      match.params.category
    ) {
      console.log(typeof match.params.category);
      const category = match.params.category;
      const filteredProducts = products.filter(
        (product) => product.category === category
      );
      setAccessoryProducts(filteredProducts);
      console.log("Filtered products:", filteredProducts);
    }
  }, [products, match?.params?.category]); // Added proper dependencies

  return (
    <>
      <Meta />

      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Row>
            <Col md={12}>
              <div
                className=' position-relative bg-image bg-overlay-60'
                style={{
                  backgroundImage: `url("../../staticuploads/ScreenPic6.jpg")`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  animation: " moveBackground 10s ease-in-out infinite",
                  transformOrigin: "center center",
                }}
              >
                <Row>
                  <Col md={{ span: 3, offset: 1 }}>
                    <div
                      style={{ textAlign: "center", marginTop: "5rem" }}
                      className=' position-relative z-index-1 '
                    >
                      <h1
                        style={{ textAlign: "justify" }}
                        className='display-4  text-white'
                      >
                        Find The{" "}
                        <strong style={{ color: "#ffff03" }}>Best </strong>
                        <strong style={{ color: "#2f99d1" }}>Accessory </strong>
                        For
                        <strong style={{ color: "green" }}> Yourself </strong>
                        <strong style={{ color: "red" }}> Now </strong>
                      </h1>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Container className='mt-3'>
            <h1 id='pro' className='text-center'>
              <Button
                className=' buts shadow btn-light rounded'
                type='button'
                onClick={() => setType("All")}
              >
                ALL
              </Button>{" "}
              <Button
                className=' buts shadow btn-light rounded'
                type='button'
                onClick={() => setType("NewArrivals")}
              >
                NEW ARRIVALS
              </Button>{" "}
              <Button
                className='buts shadow btn-light rounded'
                type='button'
                onClick={() => setType("Popular")}
              >
                POPULAR
              </Button>
            </h1>
            <h2 className='text-end'>
              <AccessoryFilterModal
                Existingvalue={match}
                FilteredValues={FilteredValues}
                setFilteredValues={setFilteredValues}
                setType={setType}
                products={AccessoryProducts}
                type={type}
              />
            </h2>
            <hr></hr>
            {type === "All" && (
              <InfiniteScroll
                dataLength={visibleProducts}
                next={loadMore}
                hasMore={visibleProducts < AccessoryProducts.length}
                // loader={<Loader />}
              >
                <Row>
                  <h4>Our Wide Range Of Accessory</h4>
                  {AccessoryProducts.slice(0, visibleProducts).map(
                    (product) => (
                      <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                        <Product product={product} />
                      </Col>
                    )
                  )}
                </Row>
              </InfiniteScroll>
            )}

            {type === "Popular" && (
              <Row>
                <h4>Popular Solutions</h4>
                {AccessoryProducts.filter(
                  (product) => product.numReviews >= 100
                ).map((product) => (
                  <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                    <Product product={product} />
                  </Col>
                ))}
              </Row>
            )}
            {type === "NewArrivals" && (
              <Row>
                <h4>Newly Arrived Solutions</h4>
                {AccessoryProducts.filter(
                  (product) => new Date(product.createdAt) > new Date(timestamp)
                ).map((product) => (
                  <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                    <Product product={product} />
                  </Col>
                ))}
              </Row>
            )}
            {type === "Filter" && (
              <Row>
                <h4>Filtered Solutions</h4>
                {filterProducts(AccessoryProducts, FilteredValues).map(
                  (product) => (
                    <Col key={product._id} sm={12} md={6} lg={4} xl={4}>
                      <Product product={product} />
                    </Col>
                  )
                )}
                {filterProducts(AccessoryProducts, FilteredValues).length ===
                  0 && <h1>Sorry, No product Found</h1>}
              </Row>
            )}
            <hr></hr>
          </Container>
        </>
      )}
    </>
  );
}
export default AccessoryScreen;
